import { render, staticRenderFns } from "./ProposalRefuseReasons.vue?vue&type=template&id=7295d781"
import script from "./ProposalRefuseReasons.vue?vue&type=script&lang=js"
export * from "./ProposalRefuseReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports